<template>
  <div class="relative">
    <div @click="$emit('filterDateModal', true)" class="border border-solid border-grey bg-white shadow-none rounded py-2 px-3 h-[36px] flex items-center justify-between gap-1 cursor-pointer">
      <div class="flex items-center gap-2">
        <span class="material-symbols-rounded text-lg text-grey-dark w-4 h-4 select-none">calendar_today</span>
        <span v-if="!startDate">{{ $t('Date') }}</span>
        <span v-else class="leading-loose">{{ gettingDate(new Date(startDate)) + ' - ' + gettingDate(new Date(endDate)) }}</span>
      </div>
      <span class="material-symbols-rounded text-base select-none">keyboard_arrow_down</span>
    </div>
    <div v-if="filterDateModal" :class="`absolute ${modalPosition} mt-1 p-4 rounded bg-white border border-solid border-grey-light`" style="z-index: 9999;">
      <div class="flex xl:flex-row flex-col gap-4 calender-date">
        <div class="col-span-1">
          <p class="mb-2 leading-tight">{{ $t('From') + ':' }}</p>
          <datepicker :inline="true" name="from" :disabledDates="disabledFilterStartDates" v-model="selectedStartDate"></datepicker>
        </div>
        <div class="col-span-1">
          <p class="mb-2 leading-tight">{{ $t('To') + ':' }}</p>
          <datepicker :inline="true" name="to" :disabledDates="disabledFilterEndDates" v-model="selectedEndDate"></datepicker>
        </div>
      </div>
      <div class="flex justify-evenly mt-1">
        <p class="text-blue-900 date-border p-2">{{selectedStartDate ? gettingDate(new Date(selectedStartDate)) : $t('No Date')}}</p>
        <div class="flex" :style="$i18n.locale === 'ar' ? 'transform: rotate(180deg);' : ''">
          <img class="w-3" src="@/assets/images/pages/arrow.svg" alt="">
          <img class="w-3" src="@/assets/images/pages/arrow.svg" alt="">
        </div>
        <p class="text-blue-900 date-border p-2">{{selectedEndDate ? gettingDate(new Date(selectedEndDate)) : $t('No Date')}}</p>
      </div>
      <div class="grid grid-cols-2 gap-4 mt-6">
        <vs-button @click="closeFilterDateModal('clear')" color="secondary" type="border" class="px-4 rounded">{{ $t('Clear') }}</vs-button>
        <vs-button @click="closeFilterDateModal()" :disabled="!isValidRange" color="primary" class="py-2 px-4 rounded">{{ $t('Filter') }}</vs-button>
      </div>
    </div>
    <div v-if="filterDateModal" @click="$emit('filterDateModal', false)" style="position: fixed; inset: 0; z-index: 999;"></div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

export default {
  props: ['modalPosition', 'filterDateModal', 'startDate', 'endDate'],
  data () {
    return {
      selectedStartDate: '',
      selectedEndDate: '',
      disabledFilterStartDates: {
        from: new Date()
      },
      disabledFilterEndDates: {
        from: new Date(),
        to: new Date() // Disable all dates up to specific date
      }
    }
  },
  computed: {
    isValidRange () {
      if (!this.selectedStartDate || !this.selectedEndDate) return false
      return new Date(this.selectedStartDate).setHours(0, 0, 0, 0) <= new Date(this.selectedEndDate).setHours(0, 0, 0, 0)
    }
  },
  watch: {
    filterDateModal: {
      immediate: true,
      handler (isOpen) {
        if (!isOpen) return
        // Start from the currently applied dates instead of an empty selection
        this.selectedStartDate = this.startDate ? new Date(this.startDate) : ''
        this.selectedEndDate = this.endDate ? new Date(this.endDate) : ''
        this.disabledFilterStartDates = {
          from: new Date()
        }
        this.disabledFilterEndDates = {
          from: new Date(),
          to: this.selectedStartDate ? new Date(this.selectedStartDate) : undefined
        }
      }
    },
    selectedStartDate (value) {
      this.disabledFilterEndDates = {
        ...this.disabledFilterEndDates,
        to: value ? new Date(value) : undefined
      }
    }
  },
  methods: {
    gettingDate (date, formateDate) {
      const savedLocale = localStorage.getItem('locale')
      const locale = savedLocale === 'en' ? 'en' : 'ar'
      const options = {day: '2-digit', month: 'short', year: 'numeric'}
      formateDate = new Date(date).toLocaleDateString(locale, options)
      return formateDate
    },
    closeFilterDateModal (type) {
      if (type === 'clear') {
        this.$emit('startDate', '')
        this.$emit('endDate', '')
      } else {
        this.$emit('startDate', this.selectedStartDate)
        this.$emit('endDate', this.selectedEndDate)
      }
      this.$emit('filterDateModal', false)
      this.$emit('loadTransactions')
    }
  },
  components: {
    Datepicker
  }
}
</script>